import React, { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { ThemeContext } from '../../App';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div className="theme-toggle">
      <Form.Check 
        type="switch"
        id="theme-switch"
        label={<span>{theme === 'light' ? (<i className="bi bi-moon me-1"></i>) : (<i className="bi bi-sun me-1"></i>)}</span>}
        checked={theme === 'dark'}
        onChange={toggleTheme}
        className="theme-switch"
      />
    </div>
  );
};

export default ThemeToggle;
